import { createReducer } from "../../../common/reduxUtil";
import { SAT_SET_MOCK_SHOP } from "./types";

const initialState = {
  mockShop: null,
};

export default createReducer(initialState, {
  [SAT_SET_MOCK_SHOP]: (state, mockShop) => ({ ...state, mockShop }),
});
